import {ArrowRight} from '@nlabs/gothamjs/icons';
import {Link} from '@nlabs/gothamjs/router';

import {primaryButton, secondaryButton} from '../../theme/classes.js';
import {CharacterShowcase} from '../CharacterShowcase/CharacterShowcase.js';
import {CinemaGallery} from '../CinemaGallery/CinemaGallery.js';
import {CreationPaths} from '../CreationPaths/CreationPaths.js';
import {CreativeFeatures} from '../CreativeFeatures/CreativeFeatures.js';
import {CreativeInvitation} from '../CreativeInvitation/CreativeInvitation.js';
import {ElementsShowcase} from '../ElementsShowcase/ElementsShowcase.js';
import {SeedanceBenefits} from '../SeedanceBenefits/SeedanceBenefits.js';
import {SeedanceShowcase} from '../SeedanceShowcase/SeedanceShowcase.js';

import type {ReactElement} from 'react';

const hero = new URL('../../assets/filmmaker-hero.png', import.meta.url).href;
export const MarketingHome = (): ReactElement => (
  <div className="mx-auto max-w-7xl px-5 sm:px-8">
    <section className="marketing-hero grid items-center gap-8 lg:grid-cols-[1.1fr_1fr]">
      <div aria-hidden="true" className="marketing-hero-backdrop pointer-events-none absolute inset-x-0 top-0 -z-10 overflow-hidden">
        <img alt="" className="h-full w-full object-cover object-[62%_center]" fetchPriority="high" src={hero} />
      </div>
      <div className="flex flex-col justify-center pt-12 pb-2 sm:pt-16 lg:py-20 lg:pr-8">
        <p className="mb-6 text-sm font-medium tracking-wide text-sky-200">New on ReactorBox</p>
        <h1 className="max-w-2xl text-5xl leading-[1.04] tracking-[-0.045em] sm:text-6xl lg:text-7xl"><span className="font-bold">Seedance 2.5.</span><br /><span className="text-violet-300">Your imagination.<br />In motion.</span></h1>
        <p className="mt-7 text-xl text-white/90">Cinematic video. A whole story waiting to happen.</p>
        <p className="mt-4 max-w-md text-base leading-relaxed text-white/65">From scroll-stopping ads to stories with a returning cast. Bring your references into motion, shape every scene, and give people a reason to keep watching.</p>
        <div className="mt-9 flex flex-wrap gap-3"><Link className={primaryButton} to="/videos">Explore Seedance 2.5 <ArrowRight size={16} /></Link><Link className={`${secondaryButton} bg-black/40!`} to="/features">Explore features</Link></div>
        <p className="mt-5 text-xs text-white/50">Start free. Build your characters and story. Upgrade to generate.</p>
        <div className="mt-7 w-fit border-t border-white/15 pt-4">
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm"><span className="text-xs text-white/60">Powered by</span><span className="font-medium text-white/90">OpenAI</span><span className="text-white/40">&amp;</span><span className="font-medium text-sky-200">Gemini</span></p>
          <p className="mt-2 text-xs text-white/50">AI writing, image creation, and analysis · Creative assistant</p>
        </div>
      </div>
      <SeedanceShowcase />
    </section>
    <CinemaGallery />
    <section className="scroll-mt-8 border-b border-white/10 py-16 sm:py-20" id="features">
      <div className="grid gap-8 md:grid-cols-[1.1fr_1fr] md:items-center">
        <div><p className="text-sm text-sky-200">Elements + image generation</p><h2 className="mt-4 text-4xl tracking-tight sm:text-5xl">Give your product <span className="text-violet-300">more life.</span></h2></div>
        <div><p className="text-lg leading-relaxed text-white/70">Start with a simple product photo. Save it as an Element, then describe the scene you want. Turn a plain catalog shot into a campaign image with motion, atmosphere, and drama.</p><p className="mt-4 text-sm leading-7 text-white/55">Reactorbox pairs your reusable Elements with its image generators, so your product stays recognizable in every new scene you create.</p><Link className="mt-6 inline-flex items-center gap-2 text-sky-200 hover:text-sky-100" to="/features">Explore Elements <ArrowRight size={16} /></Link></div>
      </div>
      <div className="mt-10 sm:mt-12"><SeedanceBenefits /></div>
    </section>
    <ElementsShowcase />
    <CharacterShowcase />
    <CreationPaths />
    <CreativeFeatures />
    <CreativeInvitation />
  </div>
);
